export default __webpack_public_path__ + "static/media/slidenote2.de8bc70f.png";